import React from 'react';
import styled, { css } from 'styled-components';

import Divider from 'components/Divider';
import { RouterNavLink } from 'components/Link';
import { Line } from 'components/Search/SearchLoadingSection';
import { H5 } from 'components/Text';
import { colors, gutterWidth, maxWidth } from 'theme';
import {
  LISTING_TYPE_HUMAN_NAME_MAP_COUNTS,
  LISTING_TYPE_PLURAL_HUMAN_NAME_MAP_COUNTS,
} from 'utils/constants';
import { listingSearchHome } from 'utils/searchHomePages';

type BackgroundProps = {
  darkMode: boolean;
};

const Background = styled.div<BackgroundProps>`
  margin-bottom: -4px;

  ${(props) =>
    props.darkMode &&
    css`
      margin-bottom: -16px;
      background: ${colors.fog};
    `}
`;

const Wrapper = styled.div`
  display: none;

  @media (min-width: 992px) {
    display: block;
    margin: 0 auto;
    max-width: ${maxWidth[3]}px;
    padding: 20px ${gutterWidth}px 0;
  }
`;

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: calc(100% + 16px);
  min-height: 30px;
  margin: 0 -8px;
  text-align: center;
`;

const ListingCountContainer = styled.div`
  margin: 0 8px;
`;

const StyledLine = styled(Line)`
  flex: 0 0 auto;
  width: 120px;
  max-width: calc(50% - 16px);
  height: 16px;
  margin: 8px;
`;

export function ListingCounts({
  darkMode,
  listingCounts,
}: {
  darkMode: boolean;
  listingCounts: Record<string, number> | null | undefined;
}) {
  const types = ['JOB', 'INTERNSHIP', 'VOLOP', 'ORG', 'GROUP', 'GRAD_PROGRAM'];

  return (
    <Background darkMode={darkMode}>
      <Wrapper>
        <Container data-qa-id="listing-counts">
          {listingCounts ? (
            <>
              {types.map((type) => {
                const count = listingCounts[type] || 0;
                return (
                  <ListingCountContainer key={type}>
                    <RouterNavLink
                      to={{
                        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
                        pathname: listingSearchHome(type),
                        search: '?q=',
                        state: { searchFrom: 'Listing Count Link' },
                      }}
                    >
                      <H5 tag="span">
                        {count.toLocaleString(CURRENT_LOCALE)}{' '}
                        {count === 1
                          ? LISTING_TYPE_HUMAN_NAME_MAP_COUNTS[type]
                          : LISTING_TYPE_PLURAL_HUMAN_NAME_MAP_COUNTS[type]}
                      </H5>
                    </RouterNavLink>
                  </ListingCountContainer>
                );
              })}
            </>
          ) : (
            <>
              {/* @ts-expect-error ts-migrate(2554) FIXME: Expected 1-3 arguments, but got 0. */}
              {new Array(types.length).fill().map((index) => (
                <StyledLine key={index} />
              ))}
            </>
          )}
        </Container>
        <Divider mt={20} mb={0} light />
      </Wrapper>
    </Background>
  );
}
